export const exams = [
    {
        id:1,
        link:'https://cmat.nta.nic.in/',
        subject:'CMAT',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'The Common Management Admission Test (CMAT) is a National Level  admission test to management programmes in the country.'
    },
    {
        id:2,
        link:'https://consortiumofnlus.ac.in/',
        subject:'CLAT',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'The Common Law Admission Test is a centralized national level admission test to twenty two National Law Universities in India. '
    },
    {
        id:3,
        link:'https://www.ets.org/gre.html',
        subject:'GRE',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'The Graduate Record Examinations is a standardized test that is an admissions requirement for many graduate schools in the United States and other countries'
    },
    {
        id:4,
        link:'https://www.upsc.gov.in/',
        subject:'UPSC',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'The Civil Services Examination is conducted by the Union Public Service Commission for recruitment to higher Civil Services of the Government of India.'
    },
    {
        id:5,
        link:'https://iimcat.ac.in/per/g01/pub/756/ASM/WebPortal/1/index.html?756@@1@@1',
        subject:'CAT',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'The Common Admission Test is a computer based test for admission in graduate management programs. The test consists of three sections.'
    },
    {
        id:6,
        link:'https://gate.iitkgp.ac.in/',
        subject:'GATE',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'The Graduate Aptitude Test in Engineering is an examination conducted in India that  tests the comprehensive understanding of  undergraduate subjects in engineering'
    },
]